import { OUVERT } from '@/configuration/presse/presseConfig';

export default function genererPlanMedia() {
  return {
    etat: OUVERT,
    dateDebut: null,
    dateFin: null,
    exerciceComptableId: null,
  };
}
